import { h, Host } from "@stencil/core";
export class OffcanvasNext {
    onClick(event) {
        event.preventDefault();
        this.el.parentElement.classList.add('offcanvas-child-active');
        this.el.nextElementSibling.classList.add('offcanvas-item-active');
    }
    render() {
        return h(Host, { key: '2a125689538d02a5fe70578381f33747db1b330e', role: "button", class: {
                'offcanvas-link': true
            } }, h("slot", { key: '8b44b1a509701ec0fa9c83aabfc7d64632df447f' }));
    }
    static get is() { return "uvex-offcanvas-next"; }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "onClick",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=offcanvas-next.js.map
